module.exports = __webpack_public_path__ + "static/media/cryptoVideo.6eca1fc6.mp4";